"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKENS_PER_PAGE = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var OAuthWindow_1 = __importDefault(require("OAuth/OAuthWindow"));
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var TokenManagementTable_1 = __importStar(require("SettingsAngular/Integrations/TokenManagement/TokenManagementTable"));
var TokenManagementOAuth_1 = __importDefault(require("SettingsAngular/Integrations/TokenManagement/TokenManagementOAuth"));
var axios_1 = __importDefault(require("axios"));
var c = (0, BemBuilder_1.default)("token-management");
var TOKENS_PER_PAGE = 10;
exports.TOKENS_PER_PAGE = TOKENS_PER_PAGE;
var TOKENS_FETCH_DEBOUNCE_MS = 1000;
var TOKENS_SAVE_DEBOUNCE_MS = 1500;
var TOKENS_SAVE_MESSAGE_MS = 1000;
var GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again";
var TOKENS_SAVED = "Integration Settings - Tokens saved";
var TOKENS_FETCHED = "Integration Settings - Tokens searched";
var TokenManagement = (function (_super) {
    __extends(TokenManagement, _super);
    function TokenManagement(props) {
        var _this = _super.call(this, props) || this;
        _this.changedTokens = mobx_1.observable.map();
        _this.customStandardFilter = Types_1.TokenDefinitionType.Custom;
        _this.tokenIndex = 0;
        _this.isCustomFilterSelected = true;
        _this.isStandardFilterSelected = false;
        _this.supportedObjects = { status: FetchUtils_1.RemoteDataStatus.NotRequested };
        _this.fetchedTokens = { status: FetchUtils_1.RemoteDataStatus.NotRequested };
        _this.searchString = "";
        _this.selectedObject = "";
        _this.isOAuthScopeChecked = false;
        _this.integrationName = "";
        _this.initialLoadComplete = false;
        _this.fetchIntegrationMetadata = function () { return __awaiter(_this, void 0, void 0, function () {
            var metadata, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setSupportedObjects({ status: FetchUtils_1.RemoteDataStatus.Loading });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.props.apiService.getMetadata(this.props.integration)];
                    case 2:
                        metadata = _a.sent();
                        this.setSupportedObjects({ status: FetchUtils_1.RemoteDataStatus.Success, data: metadata.supportedObjects });
                        this.setSelectedObject(metadata.supportedObjects[0]);
                        this.setIntegrationName(metadata.displayName);
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setSupportedObjects({ status: FetchUtils_1.RemoteDataStatus.Error, error: GENERIC_ERROR_MESSAGE });
                        this.props.notifyUser.error(GENERIC_ERROR_MESSAGE);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        _this.debouncedFetchTokens = (0, lodash_1.debounce)(_this.fetchTokens, TOKENS_FETCH_DEBOUNCE_MS);
        _this.authorizeUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var authorizeURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authorizeURL = this.props.apiService.returnAuthorizeLink(this.props.integration);
                        return [4, OAuthWindow_1.default.show(authorizeURL)];
                    case 1:
                        _a.sent();
                        return [4, this.fetchTokens()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.setSearchTerm = function (searchString) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setSearchString(searchString);
                return [2];
            });
        }); };
        _this.saveTokenSelection = function () { return __awaiter(_this, void 0, void 0, function () {
            var changedTokens, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        changedTokens = __spreadArray([], __read(this.changedTokens.values()), false);
                        return [4, this.props.apiService.storeTokens(changedTokens, this.props.integration)];
                    case 1:
                        _a.sent();
                        this.props.telemetry.trackOnly(TOKENS_SAVED, {
                            selectedTokens: {
                                count: changedTokens.filter(function (token) { return token.active === true; }).length,
                                changedTokens: changedTokens
                                    .filter(function (token) { return token.active === true; })
                                    .map(function (token) {
                                    return {
                                        object_type: token.providerData.objectType,
                                        name: token.name,
                                        integration_name: _this.props.integration,
                                    };
                                }),
                            },
                            deselectedTokens: {
                                count: changedTokens.filter(function (token) { return token.active === false; }).length,
                                changedTokens: changedTokens
                                    .filter(function (token) { return token.active === false; })
                                    .map(function (token) {
                                    return {
                                        object_type: token.providerData.objectType,
                                        name: token.name,
                                        integration_name: _this.props.integration,
                                    };
                                }),
                            },
                        });
                        this.props.notifyUser.success("Token selection saved.", TOKENS_SAVE_MESSAGE_MS);
                        this.resetChangedTokens();
                        return [3, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.props.notifyUser.error("There was a problem saving your tokens. Please try again.");
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        _this.debouncedSaveTokenSelection = (0, lodash_1.debounce)(_this.saveTokenSelection, TOKENS_SAVE_DEBOUNCE_MS);
        _this.handleCheckboxClick = function (token) {
            _this.selectToken(token, !_this.isSelected(token));
        };
        _this.selectAllTokens = function () {
            if (_this.fetchedTokens.status !== FetchUtils_1.RemoteDataStatus.Success) {
                return;
            }
            var isAllSelected = !_this.isAllSelected;
            _this.fetchedTokens.data.forEach(function (token) { return _this.selectToken(token, isAllSelected); });
        };
        _this.isSelected = function (fetchedToken) {
            if (_this.changedTokens.has(fetchedToken.id)) {
                return _this.changedTokens.get(fetchedToken.id).active;
            }
            else {
                return fetchedToken.active;
            }
        };
        return _this;
    }
    TokenManagement.prototype.componentDidMount = function () {
        this.fetchIntegrationMetadata();
        this.fetchTokensWhenNeeded();
    };
    TokenManagement.prototype.componentWillUnmount = function () {
        if (this.fetchDisposer) {
            this.fetchDisposer();
        }
    };
    Object.defineProperty(TokenManagement.prototype, "isAllSelected", {
        get: function () {
            return (this.fetchedTokens.status === FetchUtils_1.RemoteDataStatus.Success &&
                this.fetchedTokens.data.length > 0 &&
                this.fetchedTokens.data.filter(function (token) { return token.definitionType === Types_1.TokenDefinitionType.Custom; }).length > 0 &&
                this.fetchedTokens.data
                    .filter(function (token) { return token.definitionType === Types_1.TokenDefinitionType.Custom; })
                    .every(this.isSelected));
        },
        enumerable: false,
        configurable: true
    });
    TokenManagement.prototype.setCustomStandardFilter = function (customStandardFilter) {
        this.customStandardFilter = customStandardFilter;
    };
    TokenManagement.prototype.setIntegrationName = function (integrationName) {
        this.integrationName = integrationName;
    };
    TokenManagement.prototype.resetTokenIndex = function () {
        this.tokenIndex = 0;
    };
    TokenManagement.prototype.incrementPage = function () {
        this.tokenIndex = this.tokenIndex + TOKENS_PER_PAGE;
    };
    TokenManagement.prototype.decrementPage = function () {
        this.tokenIndex = this.tokenIndex - TOKENS_PER_PAGE;
    };
    TokenManagement.prototype.setIsCustomTokenSelected = function (bool) {
        this.isCustomFilterSelected = bool;
    };
    TokenManagement.prototype.setIsStandardTokenSelected = function (bool) {
        this.isStandardFilterSelected = bool;
    };
    TokenManagement.prototype.setIsOAuthScopeChecked = function (isOAuthScopeChecked) {
        this.isOAuthScopeChecked = isOAuthScopeChecked;
    };
    TokenManagement.prototype.setFetchedTokens = function (fetchedTokens) {
        this.fetchedTokens = fetchedTokens;
    };
    TokenManagement.prototype.setSupportedObjects = function (supportedObjects) {
        this.supportedObjects = supportedObjects;
    };
    TokenManagement.prototype.setSearchString = function (searchString) {
        this.searchString = searchString;
        this.resetTokenIndex();
    };
    TokenManagement.prototype.setSelectedObject = function (selectedObject) {
        this.selectedObject = selectedObject;
        this.resetTokenIndex();
    };
    TokenManagement.prototype.setInitialLoadComplete = function (initialLoadComplete) {
        this.initialLoadComplete = initialLoadComplete;
    };
    TokenManagement.prototype.handleStandardCustomFilter = function (selectedFilter) {
        if (selectedFilter === TokenManagementTable_1.DefinitionType.Custom) {
            this.setIsCustomTokenSelected(!this.isCustomFilterSelected);
        }
        else if (selectedFilter === TokenManagementTable_1.DefinitionType.Standard) {
            this.setIsStandardTokenSelected(!this.isStandardFilterSelected);
        }
        if ((this.isStandardFilterSelected && this.isCustomFilterSelected) ||
            (!this.isStandardFilterSelected && !this.isCustomFilterSelected)) {
            this.setCustomStandardFilter(null);
        }
        else if (this.isStandardFilterSelected) {
            this.setCustomStandardFilter(Types_1.TokenDefinitionType.Standard);
        }
        else if (this.isCustomFilterSelected) {
            this.setCustomStandardFilter(Types_1.TokenDefinitionType.Custom);
        }
        this.resetTokenIndex();
    };
    TokenManagement.prototype.fetchTokensWhenNeeded = function () {
        var _this = this;
        this.fetchDisposer = (0, mobx_1.reaction)(function () {
            var _a = _this, selectedObject = _a.selectedObject, searchString = _a.searchString, tokenIndex = _a.tokenIndex, customStandardFilter = _a.customStandardFilter;
            return {
                selectedObject: selectedObject,
                searchString: searchString,
                tokenIndex: tokenIndex,
                customStandardFilter: customStandardFilter,
            };
        }, function () {
            _this.setFetchedTokens({ status: FetchUtils_1.RemoteDataStatus.Loading });
            _this.debouncedFetchTokens();
        });
    };
    TokenManagement.prototype.fetchTokens = function () {
        return __awaiter(this, void 0, Promise, function () {
            var params, tokens, e_3, status, error, responseData, error_1, error_2;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.setFetchedTokens({ status: FetchUtils_1.RemoteDataStatus.Loading });
                        params = {
                            objectType: this.selectedObject,
                            searchTerm: this.searchString,
                        };
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        return [4, this.props.apiService.fetchTokens(__assign(__assign({}, params), { start: this.tokenIndex, limit: TOKENS_PER_PAGE, definitionType: this.customStandardFilter }), this.props.integration)];
                    case 2:
                        tokens = _e.sent();
                        if (this.initialLoadComplete) {
                            this.props.telemetry.trackOnly(TOKENS_FETCHED, __assign(__assign({}, params), { integration_name: this.props.integration, page: Math.ceil((this.tokenIndex + 1) / TOKENS_PER_PAGE) }));
                        }
                        this.setInitialLoadComplete(true);
                        this.setFetchedTokens({ status: FetchUtils_1.RemoteDataStatus.Success, data: tokens });
                        return [3, 5];
                    case 3:
                        e_3 = _e.sent();
                        status = FetchUtils_1.RemoteDataStatus.Error;
                        error = GENERIC_ERROR_MESSAGE;
                        if (!axios_1.default.isAxiosError(e_3)) {
                            this.setFetchedTokens({ status: status, error: error });
                            this.props.notifyUser.error(error);
                        }
                        else if (((_a = e_3.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                            responseData = (_b = e_3.response) === null || _b === void 0 ? void 0 : _b.data;
                            if (((_c = responseData.error.additionalInfo) === null || _c === void 0 ? void 0 : _c.errorCode) === ErrorCodes_1.TMSErrorCode.OAUTH_SCOPE_MISMATCH) {
                                error_1 = ErrorCodes_1.TMSErrorCode.OAUTH_SCOPE_MISMATCH;
                                this.setFetchedTokens({ status: status, error: error_1 });
                            }
                            else if (((_d = responseData.error.additionalInfo) === null || _d === void 0 ? void 0 : _d.errorCode) === ErrorCodes_1.TMSErrorCode.OAUTH_REFRESH_TOKEN_EXPIRED) {
                                error_2 = ErrorCodes_1.TMSErrorCode.OAUTH_REFRESH_TOKEN_EXPIRED;
                                this.setFetchedTokens({ status: status, error: error_2 });
                                this.props.notifyUser.error("Your authentication has expired. Please disable and re-enable your ".concat(this.integrationName, " integration in the integration settings."));
                            }
                            else {
                                this.setFetchedTokens({ status: status, error: error });
                                this.props.notifyUser.error(error);
                            }
                        }
                        return [3, 5];
                    case 4:
                        this.setIsOAuthScopeChecked(true);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    TokenManagement.prototype.resetChangedTokens = function () {
        var _this = this;
        if (this.fetchedTokens.status !== FetchUtils_1.RemoteDataStatus.Success) {
            return;
        }
        this.fetchedTokens.data.forEach(function (token) {
            var changedToken = _this.changedTokens.get(token.id);
            if (changedToken) {
                token.active = changedToken.active;
            }
        });
        this.changedTokens.clear();
    };
    TokenManagement.prototype.selectToken = function (token, isSelected) {
        if (token.definitionType !== Types_1.TokenDefinitionType.Custom) {
            return;
        }
        if (token.active === isSelected) {
            this.changedTokens.delete(token.id);
        }
        else {
            this.changedTokens.set(token.id, __assign(__assign({}, token), { active: isSelected }));
        }
        this.debouncedSaveTokenSelection();
    };
    TokenManagement.prototype.render = function () {
        var _this = this;
        if (!this.isOAuthScopeChecked) {
            return (react_1.default.createElement("div", { className: c("loading") },
                react_1.default.createElement(kaleidoscope_1.Spinner, { size: kaleidoscope_1.SpinnerSize.Large, primary: true })));
        }
        else if (this.fetchedTokens.status === FetchUtils_1.RemoteDataStatus.Error &&
            this.fetchedTokens.error === ErrorCodes_1.TMSErrorCode.OAUTH_SCOPE_MISMATCH) {
            return (react_1.default.createElement("div", { className: c() },
                react_1.default.createElement(TokenManagementOAuth_1.default, { authorizeUser: function () { return _this.authorizeUser(); }, integrationName: this.integrationName })));
        }
        else {
            return (react_1.default.createElement(TokenManagementTable_1.default, { searchString: this.searchString, selectObject: this.setSelectedObject, selectedObject: this.selectedObject, setSearchTerm: this.setSearchTerm, supportedObjects: this.supportedObjects, fetchedTokens: this.fetchedTokens, incrementPage: this.incrementPage, decrementPage: this.decrementPage, tokenIndex: this.tokenIndex, isCustomFilterSelected: this.isCustomFilterSelected, isStandardFilterSelected: this.isStandardFilterSelected, handleStandardCustomFilter: this.handleStandardCustomFilter, isAllSelected: this.isAllSelected, handleCheckboxClick: this.handleCheckboxClick, selectAllTokens: this.selectAllTokens, isSelected: function (token) { return (0, mobx_1.computed)(function () { return _this.isSelected(token); }).get(); } }));
        }
    };
    var _a, _b, _c, _d, _e, _f, _g, _h;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "changedTokens", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TokenManagement.prototype, "isAllSelected", null);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof Types_1.TokenDefinitionType !== "undefined" && Types_1.TokenDefinitionType) === "function" ? _a : Object)
    ], TokenManagement.prototype, "customStandardFilter", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "tokenIndex", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "isCustomFilterSelected", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "isStandardFilterSelected", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_b = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _b : Object)
    ], TokenManagement.prototype, "supportedObjects", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_c = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _c : Object)
    ], TokenManagement.prototype, "fetchedTokens", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "searchString", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "selectedObject", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "isOAuthScopeChecked", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "integrationName", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "initialLoadComplete", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Types_1.TokenDefinitionType !== "undefined" && Types_1.TokenDefinitionType) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setCustomStandardFilter", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setIntegrationName", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "resetTokenIndex", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "incrementPage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "decrementPage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setIsCustomTokenSelected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setIsStandardTokenSelected", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setIsOAuthScopeChecked", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setFetchedTokens", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _f : Object]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setSupportedObjects", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setSearchString", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setSelectedObject", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "setInitialLoadComplete", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof TokenManagementTable_1.DefinitionType !== "undefined" && TokenManagementTable_1.DefinitionType) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "handleStandardCustomFilter", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "fetchIntegrationMetadata", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "authorizeUser", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], TokenManagement.prototype, "setSearchTerm", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "resetChangedTokens", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof Types_1.TmsToken !== "undefined" && Types_1.TmsToken) === "function" ? _h : Object, Boolean]),
        __metadata("design:returntype", void 0)
    ], TokenManagement.prototype, "selectToken", null);
    TokenManagement = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TokenManagement);
    return TokenManagement;
}(react_1.default.Component));
exports.default = TokenManagement;
